import React from "react";
import { IconCircle } from "../../assets/icons";
function TitleWithLine({ titleText }) {
  return (
    <div className="mt-45 mb-1 text-line">
      <span className="text-line-bg ">
        <h2
          className="fw-bold d-inline-block pe-3 fs-normal
        "
        >
          {titleText}
        </h2>
        {/* <IconCircle fillColor="#d9d9d9" />
        <IconCircle fillColor="#d9d9d9" />
        <IconCircle fillColor="#d9d9d9" /> */}
      </span>
    </div>
  );
}
export default TitleWithLine;
